import React, { useEffect } from 'react';
import Button from '../Button';
import InteractiveButton from '../Button/InteractiveButton';
import { CloseBtn } from './icons';
import styled from 'styled-components';

type ModalProps = {
	children: React.ReactNode;
	header?: string | React.ReactNode;
	headerCloseBtn?: boolean;
	headerCloseBtnIcon?: any;
	actionButtons?: React.ReactNode | boolean;
	action?: string;
	onAction?: () => void;
	onClose?: () => void;
	className?: string;
	modalcontainerClassName?: string;
	imagePath?: any;
	autoHideDuration?: number;
	remove?: boolean;
	footerNotReq?: boolean;
	width?: string;
	height?: string;
	innerHeight?;
	innerWidth?;
	removeFooter?: boolean;
};

const MODAL = styled.div`
	&.modal-overlay-bot {
		@media (max-width: 600px) {
			justify-content: flex-end;
		}

		&.monacoCart {
			align-items: flex-end !important;
			& > .modal-container-bot {
				width: 400px;
				& > header {
					display: none;
				}
			}
			padding-top: unset !important;
		}
		overflow: none;
		position: fixed;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		inset: 0;
		width: ${(props) => (props.width ? props.width : '100vw')};
		height: ${(props) => (props.height ? props.height : '100vh')};
		background-color: var(--black-40);
		z-index: 99999999;

		&.priority-1-modal {
			z-index: 102;
		}

		&.priority-2-modal {
			z-index: 103;
		}

		&.priority-3-modal {
			z-index: 104;
		}

		&.logout-modal {
			z-index: 105;
		}

		& > .modal-container-bot {
			&.ff-product-overlay {
				overflow-y: auto !important;
				width: calc(100vw - 96px) !important;
				max-height: calc(100vh - 90px) !important;
				max-width: 1200px;
				min-width: 681px;
				min-height: 500px;
				@media (max-width: 600px) {
					width: 100vw !important;
					min-width: unset;
				}
				& > div.body1 {
					padding-bottom: 20px;
				}
			}
			&.remove {
				overflow: hidden;
				& > div {
					height: 100%;
				}
			}
			display: flex;
			flex-direction: column;
			width: 100vw;
			height: 100vh;
			overflow-y: auto;
			box-shadow: 0 24px 48px 0 rgba(0, 0, 0, 0.28);
			background-color: #fff;

			& > img {
				padding-bottom: 8px;
			}

			& > header {
				display: flex;
				padding: 12px 12px 0 24px;
				gap: 12px;
				background-color: #fff;

				h5 {
					margin-top: 12px;
				}

				.top-close {
					display: flex;
					margin-left: auto;
					color: var(--black-40);

					svg {
						cursor: pointer;
					}
				}
			}

			& > .body {
				overflow: auto;
				line-height: 1.5;
			}

			& > footer {
				display: flex;
				justify-content: flex-end;
				gap: 16px;
				padding: 36px 24px 24px;
				margin-top: auto;
			}
		}
	}
`;

const Modal = ({
	children,
	header,
	headerCloseBtn = false,
	headerCloseBtnIcon,
	action,
	onAction,
	actionButtons,
	onClose,
	className,
	modalcontainerClassName,
	imagePath,
	autoHideDuration,
	remove,
	footerNotReq,
	innerHeight,
	innerWidth,
	removeFooter,
}: ModalProps) => {
	console.log();
	useEffect(() => {
		if (autoHideDuration) {
			setTimeout(() => {
				onClose && onClose();
			}, autoHideDuration);
		}
	}, []);
	return (
		<MODAL
			className={`${className ? className : ''} modal-overlay-bot`}
			onClick={onClose ?? (() => window.history.back())}
			innerHeight={innerHeight}
			innerWidth={innerWidth}
		>
			<div
				className={`${`modal-container-bot ${modalcontainerClassName}`} ${
					remove ? 'remove' : ''
				}`}
				onClick={(event) => event.stopPropagation()}
			>
				{imagePath && !remove ? (
					<img src={imagePath} alt='' width='15' height='15' />
				) : null}
				{remove ? null : (
					<header>
						{header ? (
							<>{typeof header === 'string' ? <h5>{header}</h5> : header}</>
						) : null}

						{headerCloseBtn ? (
							<div className='top-close'>
								<InteractiveButton
									icon={headerCloseBtnIcon ?? <CloseBtn />}
									title='Close'
									hoverable='none'
									onClick={onClose ?? (() => window.history.back())}
								/>
							</div>
						) : null}
					</header>
				)}
				<div className={`${remove ? '' : 'body'} body1`}>{children}</div>
				{actionButtons !== false && !remove && !footerNotReq && (
					<>
						{removeFooter ? null : (
							<>
								{actionButtons ? (
									<footer>{actionButtons}</footer>
								) : (
									<footer>
										<Button
											onClick={onClose ?? (() => window.history.back())}
											buttonType='light'
										>
											<p>Cancel</p>
										</Button>
										<Button onClick={onAction}>
											<p>{action}</p>
										</Button>
									</footer>
								)}
							</>
						)}
					</>
				)}
			</div>
		</MODAL>
	);
};

export default Modal;
